webpackJsonp([2],[
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(6);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);

__webpack_require__(7);

$(document).ready(function () {
    var page = 1;

    $("#loadMore").click(function () {
        page++;
        $.ajax({
            type: "GET",
            url: window.location.origin + "/info/api/list", //"http://lingxi.aliyun.test:8001/info/api/list",
            data: { page: page },
            success: function success(response) {
                var dom = '';
                response.data.forEach(function (element) {
                    dom += '<div class="content">\n                <a target="_blank" href=' + (window.location.origin + '/info/detail/' + element.aid) + '>\n                        <img src="https://img.alicdn.com/tfs/TB1jOL3oAyWBuNjy0FpXXassXXa-400-240.png" alt="" class="preloadImg">\n                        <img src=' + element.firstImg + ' alt="" class="realImg" onload="handleOnload.call(this)">\n                 \n                </a>\n                <p class=\'title\'>\n                    <a target="_blank" href=' + (window.location.origin + '/info/detail/' + element.aid) + '>' + element.title + '</a>\n                </p>\n                <p class=\'summary\'>\n                    ' + element.abstractContent + '\n                </p>\n                <div class="info">\n                    <span style="float: left;">' + element.blogUserVO.nickName + ' \xB7 ' + element.ctime + '</span>\n\n                    <span style="float: right;">' + element.hitCount + '\u4EBA\u6D4F\u89C8</span>  \n                </div>\n            </div>';
                });
                $('.listContainer').append(dom);

                console.log(page, '==============');
            },
            error: function error(msg) {
                console.log(msg, 'msg=======');
            }
        });
    });
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[5]);


// WEBPACK FOOTER //
// js/index.js